import * as React from 'react';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import RaisedButton from 'material-ui/RaisedButton';
import { BusinessState, BusinessResponse } from '../business/business.types';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
import ReactTable from 'react-table';
import CommonFeatures from '../commons/CommonFeatures';
import { EmailResult, EmailResultState } from './Types';
import TextField from 'material-ui/TextField';
import { overlayStyle, renderOverlayLoading } from 'src/util/Overlay';

type TableData = {
  readonly email: string
  readonly status: string
  readonly openCount: number
};

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly emailResultState: EmailResultState
  readonly businessState: BusinessState
  readonly getEmailResults: (subject: string) => Promise<Response>
  readonly getBusiness: () => Promise<BusinessResponse>
};

type States = {
  readonly loading: boolean
  readonly subjectToSearch: string
  readonly emailResults: EmailResult[]
};

class EmailResultComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
        loading: false,
        subjectToSearch: '',
        emailResults: []

    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps && !isAuthTokenExpired() && nextProps.authState.statusCode === 200) {
      this.setState({
        emailResults: nextProps.emailResultState.emailResults
      });
    }
  }

  componentWillUnmount() {
    this.setState({loading: false, subjectToSearch: ''});
  }

  render() {
    const { authState, businessState } = this.props;

    return (
      <CommonFeatures
        authState={authState}
        businessState={businessState}
      >
        <div className="page-header-row row mt-2">
          <div className="col-auto">
            <h3>Email Result</h3>
          </div>
        </div>
        <div className="row mb-2 animated fadeIn">
            <div>
                <div className="container">
                    <div className="row row-full">
                        <div className="col-auto">
                            <TextField
                                fullWidth={true}
                                floatingLabelText="Subject"
                                value={this.state.subjectToSearch}
                                onChange={this.handleSubjectChange}
                            />
                        </div>
                        <div className="col-auto mt-4">
                            <RaisedButton
                                label="Search"
                                primary={true}
                                onClick={this.getEmailResults}
                            />
                        </div>
                    </div>
                </div>  
            </div>
        </div>
        <div 
            className="row mb-2 mt-2 animated fadeIn"
            style={overlayStyle(!this.state.loading)}
        >
         {renderOverlayLoading(!this.state.loading, '25%')}
          <div className="col-12">
            {this.renderResultTable()}
          </div>
        </div>
      </CommonFeatures>
    );
  }

  private renderResultTable = (): JSX.Element => {
    return(
      <ReactTable
        data={this.state.emailResults.map((emailResult: EmailResult) => this.createTableData(emailResult))}
        columns={[
          {
            accessor: 'email',
            Header: 'Email',
            style: {textAlign: 'center'}
          },
          {
            accessor: 'status',
            Header: 'Status',
            style: {textAlign: 'center'}
          },
          {
            accessor: 'openCount',
            Header: 'Open Count',
            style: {textAlign: 'center'}
          }
        ]}
        defaultPageSize={20}
        className="-striped -highlight"
      />
    );
  }

  private createTableData = (emailResult: EmailResult): TableData => {
    return({
      email: emailResult.to_email,
      status: emailResult.status,
      openCount: emailResult.opens_count
    });
  }

  private handleSubjectChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      subjectToSearch: newValue
    })

  private getEmailResults = () => {
      const { subjectToSearch } = this.state;
      
      if ( subjectToSearch ) {
          this.setState({loading: true});
          this.props.getEmailResults(subjectToSearch).then(
              response => {
                switch (this.props.emailResultState.statusCode) {
                    case 200:
                        return this.setState({emailResults: this.props.emailResultState.emailResults, loading: false});
                    default:
                        return this.setState({ emailResults: [], loading: false });
              }
            }
          );
      }
  }

}

export default EmailResultComponent;



// WEBPACK FOOTER //
// ./src/emailTemplate/EmailResultComponent.tsx